import styles from './CaseStudies.module.scss';
import { CaseStudyIntroduction } from './CaseStudyIntroduction';
import { CaseStudyBanner } from './CaseStudyBanner';
import { CASE_STUDIES, CaseStudyName } from './constants';
import { useState } from 'react';
import { APP_ROUTES } from 'routes/routes';
import { getStaticMediaPathCreator } from 'utils/getStaticMediaPathCreator';
import { FortifyLogo } from 'assets/case-study-logos';
import { isDefined } from 'utils/isDefined';

export const CaseStudies = ({ screenId }: { screenId: string }) => {
  //Change to some kind of carousel when more case studies are added, currently we have only 1
  const [activeCaseStudy] = useState(CASE_STUDIES.FORTIFY);
  const caseStudyConfig = CASE_STUDY_CONFIG[activeCaseStudy];

  if (!isDefined(caseStudyConfig)) return null;
  return (
    <div
      id={screenId}
      className={styles.sectionRoot}
      style={
        {
          '--bg-image-url': `url(${caseStudyConfig.bannerUrl})`,
        } as React.CSSProperties
      }>
      <div className={styles.sectionContentLayout}>
        <CaseStudyIntroduction />
        <CaseStudyBanner config={caseStudyConfig} />
      </div>
    </div>
  );
};

export const CASE_STUDY_PATHS = {
  FORTIFY_CASE_STUDY_PATH: 'industrial-iot-asset-monitoring-platform-fortify',
} as const;

const CASE_STUDY_CONFIG: Record<
  CaseStudyName,
  { logo: React.ReactNode; bannerUrl: string; description: string; link: string }
> = {
  [CASE_STUDIES.FORTIFY]: {
    logo: <FortifyLogo />,
    bannerUrl: getStaticMediaPathCreator(CASE_STUDIES.FORTIFY)(`home-fortify-banner-v1.png`),
    description: 'I want to be the FitBit of the dock and door equipment world to help my clients be more efficient.',
    link: APP_ROUTES.CASE_STUDIES.routeCreator(CASE_STUDY_PATHS.FORTIFY_CASE_STUDY_PATH),
  },
} as const;
